import { Button } from '../Button/index.js';
import Modal from '../Modal/index.js';
import Typography from '../Typography/index.js';

interface DeleteModalProps {
  onClose: () => void;
  onDelete: () => void;
  loading: boolean;
  text: string;
  label: string;
  isOpen: boolean;
}

export default function DeleteModal({
  onDelete,
  onClose,
  text,
  label,
  loading,
  isOpen,
}: DeleteModalProps): JSX.Element {
  return (
    <Modal size="S" onClickClose={onClose} isOpen={isOpen} title={`Remove ${label}?`}>
      <div className="flex flex-col gap-y-4">
        <Typography variant="largeBody"> {text} </Typography>
        <div className="flex gap-x-4 mt-8">
          <Button type="button" loading={loading} shrink onClick={onDelete}>
            Remove {label}
          </Button>
          <Button type="button" onClick={onClose} variant="outline" shrink>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
